module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/ATM-598f23992ffcedba07204c32f698bc6b.svg";